import React, { useCallback, useEffect, useState } from 'react';
import { ReloadOutlined, SyncOutlined, UserSwitchOutlined } from '@ant-design/icons';
import { Button, PageHeader, Table, Layout, Typography, Space, Switch } from 'antd';
import { apiClient, apiErrorMessage } from '../../../utils';
import { Delegation } from '../../../models';
import moment from 'moment';

export function DelegationsPage() {
  const { Content } = Layout;
  const { Text } = Typography;

  const [loading, setLoading] = useState(false);
  const [delegations, setDelegations] = useState<Delegation[]>();
  const [showAll, setShowAll] = useState(false);

  const loadDelegations = useCallback(() => {
    setLoading(true);
    apiClient
      .get('delegations?showAll=' + (showAll ? 'true' : 'false'))
      .then(response => {
        setDelegations(response.data);
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [showAll]);

  useEffect(() => {
    loadDelegations();
  }, [loadDelegations]);

  const syncWithErp = () => {
    setLoading(true);
    apiClient
      .get('delegations/erp-sync?showAll=' + (showAll ? 'true' : 'false'))
      .then(response => {
        setDelegations(response.data);
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onRefreshClick = () => {
    loadDelegations();
  };

  const onSyncClick = () => {
    syncWithErp();
  };

  const onShowAllChange = (value: boolean) => {
    setShowAll(value);
  };

  const tableColumns = [
    {
      title: 'Vekalet no',
      dataIndex: 'routingId',
      key: 'routingId',
      render: (routingId: string, delegation: Delegation) => <Text type={delegation.isEffective ? 'success' : 'danger'}>{routingId}</Text>,
    },
    {
      title: 'Vekalet veren',
      dataIndex: 'delegatorEmployeeNumber',
      key: 'delegatorEmployeeNumber',
      render: (delegatorEmployeeNumber: string, delegation: Delegation) =>
        delegation.delegator?.fullName || 'Sicil no: ' + delegatorEmployeeNumber,
    },
    {
      title: 'Vekalet eden',
      dataIndex: 'delegateEmployeeNumber',
      key: 'delegateEmployeeNumber',
      render: (delegateEmployeeNumber: string, delegation: Delegation) =>
        delegation.delegate?.fullName || 'Sicil no: ' + delegateEmployeeNumber,
    },
    {
      title: 'Başlangıç',
      dataIndex: 'beginDate',
      key: 'beginDate',
      render: (beginDate: string) => moment(beginDate).format('DD.MM.yyyy HH:mm:ss'),
    },
    {
      title: 'Bitiş',
      dataIndex: 'endDate',
      key: 'endDate',
      render: (endDate: string) => moment(endDate).format('DD.MM.yyyy HH:mm:ss'),
    },
    {
      title: 'İptal edilmiş',
      dataIndex: 'disabled',
      key: 'disabled',
      render: (disabled: boolean) => (disabled ? 'Evet' : 'Hayır'),
    },
    {
      title: 'Aktif',
      dataIndex: 'isEffective',
      key: 'isEffective',
      render: (isEffective: boolean) => (isEffective ? 'Evet' : 'Hayır'),
    },
  ];

  return (
    <>
      <PageHeader
        title={
          <>
            <UserSwitchOutlined /> Vekaletler
          </>
        }
        extra={[
          <Space>
            <Switch checked={showAll} onChange={onShowAllChange} />
            <span>Tümünü göster</span>
          </Space>,
          <Button type="primary" key="sync" onClick={onSyncClick} icon={<SyncOutlined />}>
            ERP ile eşle
          </Button>,
          <Button key="refresh" onClick={onRefreshClick} icon={<ReloadOutlined />}>
            Yenile
          </Button>,
        ]}
      />
      <Content>
        <Table columns={tableColumns} dataSource={delegations} loading={loading} scroll={{ x: '100%' }} pagination={false} />
      </Content>
    </>
  );
}
